import ReadingLogs from './ReadingLogs';

export default ReadingLogs;
